export default `subscription createdTodo {
  createdTodo {
	todoId
	body
	createdOn
	createdBy
  }
}`;
